import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'questionnaires',
  inputShow: gql`
    query questionnaires($input: QuestionnaireQueryInput) {
      questionnaires(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'License',
    label: 'Questionnaires',
    order: 3,
  },
};
